// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import WebIM from './utils/plugin/webim';
import 'xlys-loading/lib/toast.css';
import Toast from 'xlys-loading';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import VueCookies from 'vue-cookies'
import './permission'
import wx from 'weixin-js-sdk';
import VueClipboard from 'vue-clipboard2'
/*import emedia from 'easemob-emedia';*/
Vue.use(VueCookies)
Vue.use(ElementUI);
Vue.use(Toast);
Vue.use(WebIM)
Vue.use(VueClipboard);
Vue.prototype.$wx = wx;
/*Vue.prototype.$emedia = emedia;*/
Vue.config.productionTip = false
/* eslint-disable no-new */
const v1 = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  WebIM,
})
export default v1




// WEBPACK FOOTER //
// ./src/main.js